import { render, staticRenderFns } from "./averrage-elec.vue?vue&type=template&id=0a4fd6fe&"
import script from "./averrage-elec.vue?vue&type=script&lang=js&"
export * from "./averrage-elec.vue?vue&type=script&lang=js&"
import style0 from "./averrage-elec.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports